import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import fastclick from 'fastclick';
import Vconsole from 'vconsole';
import animated from 'animate.css';
import './assets/css/reset.css';
import api from './assets/js/api';
import './assets/iconfont/iconfont.css';
import 'mint-ui/lib/style.css';
import clipboard from 'clipboard';

Vue.prototype.clipboard = clipboard;

Vue.use(animated);
Vue.config.productionTip = false;

fastclick.attach(document.body);

import { DatetimePicker } from 'mint-ui';
Vue.component(DatetimePicker.name, DatetimePicker);

/*const vConsole = new Vconsole();
export default vConsole;*/

Vue.prototype.$api = api; //注册全局api

fastclick.prototype.focus = function (targetElement) {
  let length;
  if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
    length = targetElement.value.length;
    targetElement.focus();
    // targetElement.setSelectionRange(length, length);


    if(targetElement.type.indexOf('number') !== 0){
      targetElement.setSelectionRange(length, length);
    }


  } else {
    targetElement.focus();
  }
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
